// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';

// Utils
import { getShowAssignments } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getSelectedTaskIdSelector, getSelectedTaskSelector } from '../../../selector/selectionToolsSelector';

// Actions
import { toggleElementShowAssignments } from '../../../../../element/task/pills/assignment/taskAssignmentActions';

// Components
import Icon from '../../../../../components/icons/Icon';
import ToolbarTool from '../../ToolbarTool';
import { useToolbarItemTranslation } from '../../../hooks/useToolbarItemTranslation';

const isShowingAssignmentsSelector = createSelector(getSelectedTaskSelector, getShowAssignments);

const mapStateToProps = createStructuredSelector({
    selectedTaskId: getSelectedTaskIdSelector,
    isShowingAssignments: isShowingAssignmentsSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchToggleShowAssignments: (id) => dispatch(toggleElementShowAssignments({ id })),
});

const AssignUserTool = (props) => {
    const { isShowingAssignments, dispatchToggleShowAssignments, selectedTaskId, item, name } = props;

    const onToggle = React.useCallback(() => {
        dispatchToggleShowAssignments(selectedTaskId);
    }, [selectedTaskId]);

    const { toolName } = useToolbarItemTranslation(item || {}, name);

    return (
        <div className="AssignUserTool">
            <ToolbarTool {...props} onClick={onToggle} name={toolName} isActive={isShowingAssignments}>
                <Icon name="toolbar-assign" />
            </ToolbarTool>
        </div>
    );
};

AssignUserTool.propTypes = {
    selectedTaskId: PropTypes.string,
    isShowingAssignments: PropTypes.bool,
    dispatchToggleShowAssignments: PropTypes.func,
    item: PropTypes.object,
    name: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignUserTool);
